(function () {
  'use strict';

  document.querySelectorAll('.custom-collection').forEach(initCustomCollection);

  function initCustomCollection(root) {
    var backdrop = root.querySelector('[data-cc-backdrop]');
    var toggles = root.querySelectorAll('[data-cc-toggle]');
    var closes = root.querySelectorAll('[data-cc-close]');

    function openPanel(name) {
      var panel = root.querySelector('[data-cc-panel="' + name + '"]');
      if (!panel) return;
      panel.hidden = false;
      requestAnimationFrame(function () {
        panel.setAttribute('data-cc-open', '');
      });
      if (backdrop) backdrop.hidden = false;
    //   document.documentElement.style.overflow = 'hidden';
      var btn = root.querySelector('[data-cc-toggle="' + name + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    function closeAllPanels() {
      root.querySelectorAll('[data-cc-panel]').forEach(function (panel) {
        panel.removeAttribute('data-cc-open');
        setTimeout(function () {
          panel.hidden = true;
        }, 250);
      });
      if (backdrop) backdrop.hidden = true;
      document.documentElement.style.overflow = '';
      toggles.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-cc-toggle');
        var panel = root.querySelector('[data-cc-panel="' + name + '"]');
        if (panel && panel.hasAttribute('data-cc-open')) {
          closeAllPanels();
        } else {
          closeAllPanels();
          openPanel(name);
        }
      });
    });

    closes.forEach(function (btn) {
      btn.addEventListener('click', closeAllPanels);
    });

    if (backdrop) backdrop.addEventListener('click', closeAllPanels);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPanels();
    });

    // Sorting: submit immediately when a sort option is chosen.
    root.querySelectorAll('[data-cc-sort-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        radio.form.submit();
      });
    });

    // Filtering: checking/unchecking a box submits the filter form right away.
    root.querySelectorAll('[data-cc-filter-checkbox]').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        checkbox.form.submit();
      });
    });

    // Wishlist toggle (stored locally per browser).
//     var wishlist = readWishlist();
//     root.querySelectorAll('[data-cc-wishlist]').forEach(function (btn) {
//       var id = btn.getAttribute('data-product-id');
//       btn.setAttribute('aria-pressed', wishlist.indexOf(id) > -1 ? 'true' : 'false');

//       btn.addEventListener('click', function (e) {
//         e.preventDefault();
//         e.stopPropagation();
//         var index = wishlist.indexOf(id);
//         if (index > -1) {
//           wishlist.splice(index, 1);
//           btn.setAttribute('aria-pressed', 'false');
//         } else {
//           wishlist.push(id);
//           btn.setAttribute('aria-pressed', 'true');
//         }
//         writeWishlist(wishlist);
//         document.dispatchEvent(new CustomEvent('custom-collection:wishlist-updated', { detail: wishlist }));
//       });
//     });
//   }

//   function readWishlist() {
//     try {
//       return JSON.parse(localStorage.getItem('cc_wishlist') || '[]');
//     } catch (e) {
//       return [];
//     }
//   }

//   function writeWishlist(list) {
//     try {
//       localStorage.setItem('cc_wishlist', JSON.stringify(list));
//     } catch (e) {
//       /* storage unavailable, ignore */
//     }
  }
})();
